<template>
  <v-container class="p-pay">
    <v-layout>
      <Stepper :value="2"></Stepper>
    </v-layout>
    <v-layout class="mt-2">
      <v-flex grow>
        <CSection title="支付保费">
          <v-layout>
            <v-flex>
              <h3 class="my-3">{{ order.productName || order.productSeriesName }}</h3>
              <p class="introduce-text mb-1">保障期限 {{ startDate }} 至 {{ endDate }} 共 {{ duration }}</p>
              <p class="introduce-text">投保员工共 {{ order.insureds }} 人</p>
            </v-flex>
            <v-flex shrink class="ml-5">
              <v-layout align-center justify-end fill-height>
                <span class="introduce-text mt-2 mr-2">总保费：</span>
                <span class="display-1 primary-text">￥{{ order.amounts }}</span>
              </v-layout>
            </v-flex>
          </v-layout>
        </CSection>
      </v-flex>
    </v-layout>

    <v-layout class="mt-4">
      <v-flex grow>
        <CSection>
          <p class="size2">请选择支付方式</p>
          <v-divider></v-divider>
          <h3 class="mt-4 mb-3">支付平台</h3>
          <v-layout class="group">
            <v-flex
              v-for="(item,index) in platforms"
              :key="item.value"
              class="group-item mr-4"
              :class="{'border-selected':index === selectedPlatform}"
              @click="selectedPlatform = index"
            >
              <img :src="item.img" class="group-item-img" style="width:90px;height:24px;" v-if="item.img">
              <p v-else style="margin-bottom:0">{{item.text}}</p>
              <img
                v-if="index === selectedPlatform"
                class="group-item-checked"
                src="https://qihuibao.oss-cn-beijing.aliyuncs.com/pay/box-checked.png"
              >
            </v-flex>
          </v-layout>
          <v-layout v-show="selectedPlatform === 0">
            <v-flex shrink>
              <v-checkbox v-model="agree" class="checkbox" label></v-checkbox>
            </v-flex>
            <v-flex shrink class="align-self-center">
              我已仔细阅读并同意<a class="primary-text" @click="tkVisible = true">《企业授权个人费用》</a>
            </v-flex>
          </v-layout>
        </CSection>
      </v-flex>
    </v-layout>

    <v-layout class="mt-4">
      <v-btn class="pay-btn mt-3" :loading="loading" color="primary" large @click="pay" :disabled="selectedPlatform === 0 && !agree">立即支付</v-btn>
    </v-layout>
    <orderPay v-model="Visible" :url="url" :orderCode="this.orderCode"></orderPay>
    <TKCost v-model="tkVisible"></TKCost>
  </v-container>
</template>

<script>
import Stepper from "../insure/components/Stepper";
import dateUtil from "@/assets/js/utils/date.js";
import orderPay from "../insure/components/orderPay";
import TKCost from "./components/TKCost";
export default {
  components: {
    Stepper,
    orderPay,
    TKCost
  },
  props: {
    orderCode: String
  },
  data() {
    return {
      url:'',
      Visible:false,
      loading: false,
      selectedPlatform: 0, // 选中的 platforms 索引
      platforms: [
        {
          img:
            "/images/weixin.png",
          text: "微信支付",
          value: 0,
          url:'/app/api/tk/pay'
        },
        {
          img:
            "",
          text: "线下支付",
          value: 2,
          url:'/app/api/tk/offlinePay'
        }
      ],
      order: {
        orderCode: "",
        userId: "",
        insurerProposalNo: "", // 支付流水号
        productName: "",
        insureStartDate: "",
        insureEndDate: "",
        insureds: 0,
        amounts: 0
      },
      agree:false,
      tkVisible:false
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    },
    businessId() {
      return this.user && this.user.userId;
    },
    startDate() {
      return this.$miment(this.order.insureStartDate).format("YYYY-MM-DD");
    },
    endDate() {
      return this.$miment(this.order.insureEndDate).format("YYYY-MM-DD");
    },
    duration() {
      return dateUtil.getDuration(this.startDate, this.endDate);
    }
  },
  created() {
    // 437551618156974080
    const data = {
      orderCode: this.orderCode,
      // orderCode:"437551618156974080",
      userId: this.businessId
    }
    this.$axios
      .post('/app/api/tk/queryOrderDetail',data)
      .then(res => {
        this.order = res.data;
      });
  },
  methods: {
    pay() {
      if (!this.order || !this.order.orderCode) {
        this.$message.error("操作异常，请退出重试");
        return false;
      }
      this.loading = true;
      let url = this.platforms[this.selectedPlatform].url; 
      // 保存支付请求
      const data = {
        orderCode: this.orderCode || this.order.orderCode,
        // orderCode:"437551618156974080",
        userId: this.businessId
      };
      this.$axios
        .post(url, data)
        .then(res => {
          if(res.data && res.data.code_url){
            this.url=res.data.code_url;
            this.Visible=true;
          } else if (res.code === 200) {
            this.$router.push("/result");
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/var";
.p-pay {
  .group {
    &-item {
      width: 225px;
      height: 57px;
      border: 1px solid $explain-color;
      flex: none;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;
      &-img {
        width: 126px;
        height: 45px;
      }
      &-checked {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 24px;
      }
    }
  }
  .pay-btn{
    width: 240px;
    height: 50px;
    margin-left: 0;
  }
  .border-selected{
      border:1px solid $primary-color !important;
  }
}
</style>

